import React, { useState } from 'react';
import { Modal, StyleSheet, TouchableOpacity, View } from 'react-native';
import { Text } from 'react-native-paper';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import { useTranslation } from 'react-i18next';
import { changeLanguage, SUPPORTED_LANGUAGES } from '../../i18n';
import { useAppColors } from '../../hooks/useAppColors';

export default function LanguageSwitcher() {
  const { t, i18n } = useTranslation();
  const colors = useAppColors();
  const [showPicker, setShowPicker] = useState(false);

  const currentLanguage = SUPPORTED_LANGUAGES.find((lang) => lang.code === i18n.language);

  return (
    <>
      <TouchableOpacity
        style={[styles.button, { borderColor: colors.border }]}
        onPress={() => setShowPicker(true)}
        activeOpacity={0.7}
      >
        <Icon name="web" size={18} color={colors.textSecondary} />
        <Text style={[styles.buttonText, { color: colors.textSecondary }]}>
          {currentLanguage?.label || 'English'}
        </Text>
      </TouchableOpacity>

      <Modal
        visible={showPicker}
        transparent
        animationType="fade"
        onRequestClose={() => setShowPicker(false)}
      >
        <TouchableOpacity
          style={styles.modalOverlay}
          activeOpacity={1}
          onPress={() => setShowPicker(false)}
        >
          <TouchableOpacity
            style={[styles.modalCard, { backgroundColor: colors.card, borderColor: colors.border }]}
            activeOpacity={1}
          >
            <View style={styles.modalHeader}>
              <Text style={[styles.modalTitle, { color: colors.text }]}>
                {t('profile.language')}
              </Text>
              <TouchableOpacity onPress={() => setShowPicker(false)}>
                <Icon name="close" size={20} color={colors.textSecondary} />
              </TouchableOpacity>
            </View>
            {SUPPORTED_LANGUAGES.map((lang) => {
              const isActive = i18n.language === lang.code;
              return (
                <TouchableOpacity
                  key={lang.code}
                  style={[
                    styles.languageRow,
                    isActive && { backgroundColor: colors.border, borderRadius: 8 },
                  ]}
                  onPress={() => {
                    changeLanguage(lang.code);
                    setShowPicker(false);
                  }}
                  activeOpacity={0.7}
                >
                  <Text
                    style={[
                      styles.languageLabel,
                      {
                        color: isActive ? colors.text : colors.textTertiary,
                        fontWeight: isActive ? '700' : '400',
                      },
                    ]}
                  >
                    {lang.label}
                  </Text>
                  {isActive && <Icon name="check" size={18} color={colors.text} />}
                </TouchableOpacity>
              );
            })}
          </TouchableOpacity>
        </TouchableOpacity>
      </Modal>
    </>
  );
}

const styles = StyleSheet.create({
  button: {
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'flex-start',
    gap: 6,
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 8,
    borderWidth: 1,
    minWidth: 110,
  },
  buttonText: {
    fontSize: 14,
    fontWeight: '500',
    flexShrink: 0,
  },
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24,
  },
  modalCard: {
    width: '100%',
    maxWidth: 320,
    borderRadius: 16,
    borderWidth: 1,
    padding: 20,
  },
  modalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
  },
  modalTitle: {
    fontSize: 17,
    fontWeight: '700',
  },
  languageRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 12,
    paddingHorizontal: 8,
  },
  languageLabel: {
    fontSize: 15,
  },
});
